import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NavigationExtras, Route, Router } from '@angular/router';
import { AlertService } from 'services/alert.service';
import { ApplicationService } from 'services/application.service';
import { NavigationService } from 'services/navigation.service';

@Component({
  selector: 'app-eftattach',
  templateUrl: './eftattach.component.html',
  styleUrls: ['./eftattach.component.scss']
})
export class EftattachComponent implements OnInit {

  form: FormGroup;
  data: any;
  application: any;
  networkIdentifier: any;
  eFTDocumentURL: any;
  filename: any;
  fileExtention: any;
  ApplicationId: any;

  constructor( private applicationService: ApplicationService, 
   private navigationService: NavigationService,
   private alertService: AlertService, private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<EftattachComponent>,
    @Inject(MAT_DIALOG_DATA) public dataRecievedToAdd: any,
    private router: Router) { }

  ngOnInit() {
    this.application = this.dataRecievedToAdd;
  }

  onSelectFile(event) {

    const file = event.target.files[0];
  
    if (file && (file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || file.type === 'application/msword')) {
  
      let filesize = file.size;
      let acceptsize = parseInt((filesize / 1024).toFixed(2));
      if (acceptsize < 2048) {
  
        const imageDetail = event.target.files[0];
        this.filename = imageDetail.name;
        var splittedName = this.filename.split(".");
        this.fileExtention = splittedName[1];
  
        if (event.target.files && event.target.files[0]) {
          const fileReader: FileReader = new FileReader();
          fileReader.readAsDataURL(event.target.files[0]);
          fileReader.onload = (event: Event) => {
            this.eFTDocumentURL = fileReader.result;
          };
        }
  
      } else {
        this.alertService.error('File size is large, Please upload less than 2 MB');
      }
      
    } else {
      this.alertService.error('Please upload JPG, JPEG, PNG and PDF only');
    }
  
  }
  
    onUpload(){    
      debugger
      if (this.eFTDocumentURL == null && this.filename == null && this.fileExtention == null) {
        this.alertService.warning('Please select EFT payment image.');
        return;
      }
  
      const finalValue = {
        eftDocumentURL : this.eFTDocumentURL,
        filename : this.filename,
        fileExtention :this.fileExtention,
        applicationId: this.application.item.id,
      }
  
      this.applicationService.saveEFTDocument(finalValue).subscribe(result => { 
        if(result != null && result.value.id > 0)
        {
          this.alertService.success('EFT document file uploaded successfully.!');
          this.navigationService.goToManageOrder();
          this.dialogRef.close(true);    
        }
      });
  
      }
      cancel(){
        this.dialogRef.close(false);    
      }
}
